import { useAuth } from '@/context/AuthContext';
import { useLeagueMemberCount } from '@/hooks/useLeagueMemberCount';
import { LeagueSettingsLayout } from '@/components/LeagueSettingsLayout';
import { EconomySetup } from '@/components/economy';
import { PaymentTracker } from '@/components/economy/PaymentTracker';
import { Loader2 } from 'lucide-react';
import { Navigate } from 'react-router-dom';

export default function LeagueBilling() {
  const { currentMembership, isSuperAdmin } = useAuth();

  const leagueId = currentMembership?.league_id;
  const canEdit =
    isSuperAdmin ||
    currentMembership?.role === 'owner' ||
    currentMembership?.role === 'admin';

  const { count: memberCount, isLoading } = useLeagueMemberCount(leagueId);

  if (!currentMembership || !leagueId) {
    return (
      <LeagueSettingsLayout activeTab="payouts">
        <p className="text-stone-600">No league selected</p>
      </LeagueSettingsLayout>
    );
  }

  if (!canEdit) {
    return <Navigate to="/settings" replace />;
  }

  if (isLoading) {
    return (
      <LeagueSettingsLayout activeTab="payouts">
        <div className="py-12 flex justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-stone-400" />
        </div>
      </LeagueSettingsLayout>
    );
  }

  return (
    <LeagueSettingsLayout activeTab="payouts">
      <div className="space-y-8">
        <EconomySetup leagueId={leagueId} memberCount={memberCount} />
        <PaymentTracker leagueId={leagueId} />
      </div>
    </LeagueSettingsLayout>
  );
}
